import { render, staticRenderFns } from "./collectConfirmationTemplates.vue?vue&type=template&id=57101afe&scoped=true"
import script from "./collectConfirmationTemplates.vue?vue&type=script&lang=js"
export * from "./collectConfirmationTemplates.vue?vue&type=script&lang=js"
import style0 from "./collectConfirmationTemplates.vue?vue&type=style&index=0&id=57101afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57101afe",
  null
  
)

export default component.exports